<template>
  <v-container fluid>
    <v-row dense>
      <v-col cols="12">
        <v-toolbar class="elevation-2">
          <v-row dense class="mt-4">
            <!--
            <v-col cols="12" sm="6" md="4">
                <DatePicker :itemAction="datePiker" :on-success="actionFieldData"/>
            </v-col>
            -->
            <v-col cols="12" sm="6" md="4">
              <SelectedGroupDinamicField :itemAction="selectedDepartamento" :on-success="actionFieldData" />
            </v-col>
          </v-row>
          <v-spacer></v-spacer>
        </v-toolbar>
        <DataTableMain :datatable="table" :on-success="successAction" :itemsAction="tableAction"/>
      </v-col>
      <v-col cols="12">
        <v-layout justify-center>
          <v-flex xs12 md11>
            <ViewDetails class="ma-2" :object="object" type="AsistenciaColaborador" :itemsAction="successAction"/>
          </v-flex>
        </v-layout>
      </v-col>
    </v-row>
    <MainFormDialog v-if="get_dialogMain.dialog" :fields="form" :model="objectMain" :urls="url" :message="message" />
  </v-container>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from 'vuex'
import DataTableMain from '@/components/tables/DataTableMain'
import MainFormDialog from '@/components/dialogs/MainFormDialog'
import SelectedGroupDinamicField from '@/components/fields/SelectedGroupDinamicField'
import ViewDetails from '@/components/ViewDetails'
import { Permission } from '@/mixins/permissionMain'
export default {
  mixins: [Permission],
  data: () => ({
    table: {
      modelMain: [],
      showSelect: true,
      singleSelect: true,
      header: {
        options: [
          { title: 'Refrescar', icon: 'mdi-cached', color: 'primary', action: 'refreshData', code: 'libre', hidden: '' },
          {
            title: 'Reportes',
            icon: 'mdi-cloud-download',
            color: 'light-blue lighten-1',
            code: 'asis.reportes',
            options: [
              { title: 'Reporte Analitico', icon: 'mdi-clipboard-text', color: 'blue darken-3', action: 'ExportAnalit' },
              { title: 'Reporte General', icon: 'mdi-clipboard-text', color: 'yellow darken-3', action: 'ExportGral' }
            ]
          }
        ],
        titles: [
          { text: 'Cve Empleado', value: 'cve_empleado', class: 'black--text' },
          { text: 'Nombre Empleado', value: 'empleado.NombreCompleto', class: 'black--text' },
          { text: 'Departamento', value: 'departamento.nombre', class: 'black--text' },
          { text: 'Activo', value: 'Activo', class: 'black--text' }
        ],
        loading: false
      },
      body: {
        data: [],
        actions: []
      },
      footer: {
        paging: true
      }
    },
    selectedDepartamento: {
      field: 'selectGroupDataServer',
      name: 'Departamentos',
      nameid: 'cct',
      url: '/config/departamentos/show',
      itemvalue: 'clave',
      rules: true,
      cols: 12
    },
    params: {},
    asistencia: {},
    form: [],
    objectMain: {},
    url: {},
    message: ''
  }),
  components: {
    DataTableMain,
    SelectedGroupDinamicField,
    ViewDetails,
    MainFormDialog
  },
  mounted () {
    // this.getUrl('POST/asistencia/show')
    this.ShowPermisos({ permisos: JSON.parse(localStorage.getItem('permisos')), tableMain: this.table })
  },
  methods: {
    ...mapActions(['getUrlServices', 'postServiceListAction', 'getUrExporPdftDataServerAction']),
    ...mapMutations(['SHOW_DIALOG_MAIN', 'CLEAR_DATA_LIST']),

    successAction (item) {
      this[item.action](item)
    },
    refreshData (item) {
      this.table.header.loading = true
      this.getUrl('POST/nomina/empleados-plazas/show')
    },
    newData (item) {
      this.asistencia = {}
      this.SHOW_DIALOG_MAIN({ type: 'create', with: 850, title: 'Nueva Asistencia' })
    },
    ExportAnalit ({ item }) {
      if (item) this.objectMain = { adscripcion_id: item.id }
      else this.objectMain = { cct: this.params.cct }

      this.form = this.get_exporByDatestForm
      this.url = this.get_urls['POST/asistencia/reportes/analitico']
      this.message = 'Registro Agregado Correctamente'
      this.SHOW_DIALOG_MAIN({ type: 'create', with: 500, title: 'Exportar Asistencia Analitica', body: { exportpdf: true } })
      // const url = this.get_urls['GET/nomina/reportes/recibos/{nomina_id}[/{adscripcion_id}]']
      // this.getUrExporPdftDataServerAction({ url: url, params: `/${item.item.id}`, replace: '/{nomina_id}[/{adscripcion_id}]', nombre: item.item.NombreCompleto })
    },
    ExportGral (item) {
      if (item) this.objectMain = { adscripcion_id: item.id }
      else this.objectMain = { cct: this.params.cct }

      this.form = this.get_exporByDatestForm
      this.objectMain = { adscripcion_id: item.id }
      this.url = this.get_urls['POST/asistencia/reportes/general']
      this.message = 'Registro Agregado Correctamente'
      this.SHOW_DIALOG_MAIN({ type: 'create', with: 500, title: 'Exportar Asistencia General', body: { exportpdf: true } })
    },
    tableAction (item) {
      this[item.action](item)
    },

    getUrl (objet) {
      if (this.get_urls != null) {
        const router = this.get_urls[objet]
        this.postServiceListAction({ url: router, data: this.params })
      } else {
        this.getUrlServices()
      }
    },
    actionFieldData (obj) {
      this.params[obj.id] = (obj.data) ? obj.data : null
      this.table.header.loading = true
      this.getUrl('POST/nomina/empleados-plazas/show')
    }

  },
  computed: {
    ...mapGetters(['get_dialogMain', 'get_urls', 'get_objects',
      'get_exporByDatestForm']),
    object () {
      if (this.table.modelMain.length > 0) {
        return this.table.modelMain[0]
      }
      return {}
    }
  },
  watch: {
    get_urls (val) {
      this.getUrl('POST/nomina/empleados-plazas/show')
    },
    get_objects (vals) {
      this.table.header.loading = false
      this.table.modelMain = []
      if (vals.length > 0) {
        this.table.modelMain.push(vals[0])
      }
      this.table.body.data = vals
    }
  },
  beforeDestroy () {
    this.CLEAR_DATA_LIST()
  }
}
</script>

<style>

</style>
